import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import API from "../api/axios";
import useMessageHelpers from "./useMessageHelpers";

export const useVtfUsers = ({ page, pageSize, q, dojoCode }) => {
    return useQuery({
        queryKey: ["vtf-users", { page, pageSize, q, dojoCode }],
        queryFn: async () => {
            const res = await API.get("/superadmin/vtf-data/users", {
                params: {
                    page,
                    per_page: pageSize,
                    q,
                    dojo_code: dojoCode
                }
            });
            return res.data;
        }
    });
};

export const useUpdateVtfUser = () => {
    const queryClient = useQueryClient();
    const { showSuccess, showError } = useMessageHelpers();
    return useMutation({
        mutationFn: async ({ id, data }) => {
            const res = await API.put(`/superadmin/vtf-data/users/${id}`, data);
            return res.data;
        },
        onSuccess: () => {
            showSuccess("Cập nhật hội viên VTF thành công");
            queryClient.invalidateQueries({ queryKey: ["vtf-users"] });
        },
        onError: (err) => {
            showError(err?.response?.data?.message || err.message || "Lỗi khi cập nhật hội viên");
        }
    });
};

export const useVtfDojos = ({ page, pageSize, q }) => {
    return useQuery({
        queryKey: ["vtf-dojos", { page, pageSize, q }],
        queryFn: async () => {
            const res = await API.get("/superadmin/vtf-data/dojos", { 
                params: { 
                    page,
                    per_page: pageSize,
                    q 
                } 
            });
            return res.data;
        }
    });
};

export const useUpdateVtfDojo = () => {
    const queryClient = useQueryClient();
    const { showSuccess, showError } = useMessageHelpers();
    return useMutation({
        mutationFn: async ({ id, data }) => {
            const res = await API.put(`/superadmin/vtf-data/dojos/${id}`, data);
            return res.data;
        },
        onSuccess: () => {
            showSuccess("Cập nhật Dojo thành công");
            queryClient.invalidateQueries({ queryKey: ["vtf-dojos"] });
        },
        onError: (err) => {
            showError(err?.response?.data?.message || err.message || "Lỗi khi cập nhật Dojo");
        }
    });
};

export const useVtfProvinces = ({ page, pageSize, q }) => {
    return useQuery({
        queryKey: ["vtf-provinces", { page, pageSize, q }],
        queryFn: async () => {
            const res = await API.get("/superadmin/vtf-data/provinces", { 
                params: { 
                    page,
                    per_page: pageSize,
                    q 
                } 
            });
            return res.data;
        }
    });
};

export const useUpdateVtfProvince = () => {
    const queryClient = useQueryClient();
    const { showSuccess, showError } = useMessageHelpers();
    return useMutation({
        mutationFn: async ({ id, data }) => {
            const res = await API.put(`/superadmin/vtf-data/provinces/${id}`, data);
            return res.data;
        },
        onSuccess: () => {
            showSuccess("Cập nhật Tỉnh/Phòng tập thành công");
            queryClient.invalidateQueries({ queryKey: ["vtf-provinces"] });
        },
        onError: (err) => {
            showError(err?.response?.data?.message || err.message || "Lỗi khi cập nhật Tỉnh/Phòng tập");
        }
    });
};

export const useVtfLookupSetting = () => {
    return useQuery({
        queryKey: ["vtf-lookup-setting-public"],
        queryFn: async () => {
            const res = await API.get("/lookup/vtf-setting");
            return res.data;
        }
    });
};

export const useVtfCodeLookup = () => {
    return useMutation({
        mutationFn: async ({ name, dob }) => {
            const res = await API.post("/lookup/vtf-code", { name, dob });
            return res.data;
        }
    });
};

export const useAdminVtfLookupSetting = () => {
    return useQuery({
        queryKey: ["vtf-lookup-setting-admin"],
        queryFn: async () => {
            const res = await API.get("/superadmin/vtf-lookup-setting");
            return res.data;
        }
    });
};

export const useUpdateAdminVtfLookupSetting = () => {
    const queryClient = useQueryClient();
    const { showSuccess, showError } = useMessageHelpers();
    return useMutation({
        mutationFn: async (enabled) => {
            const res = await API.post("/superadmin/vtf-lookup-setting", { enabled });
            return res.data;
        },
        onSuccess: () => {
            showSuccess("Cập nhật cài đặt thành công");
            queryClient.invalidateQueries({ queryKey: ["vtf-lookup-setting-admin"] });
            queryClient.invalidateQueries({ queryKey: ["vtf-lookup-setting-public"] });
        },
        onError: (err) => {
            showError(err?.response?.data?.message || err.message || "Lỗi khi cập nhật cài đặt");
        }
    });
};

export const useVtfMemberByHash = (hash) => {
    return useQuery({
        queryKey: ["vtf-member-share", hash],
        queryFn: async () => {
            const res = await API.get(`/lookup/vtf-member/${hash}`);
            return res.data;
        },
        enabled: !!hash
    });
};
